//Constants file for ReusableComponents

//Constants for Project.jsx
export const CONTRIBUTIONS = "Key contributions:";
export const TOOLS = "Tools:";
export const LEARN_MORE = "Learn more about my experience!";
